module.exports = __webpack_public_path__ + "img/sapphire@2x.eb31f2e.jpg";